<template>
    <div class="myNewFoot"> 
         <div v-if="show" class="FootTop u-max-width u-p-t-70 u-p-b-60">
            <div class="FootTilte">
                ONEBO-简单做跨境 一产品卖全球
            </div>
            <div  class="FootTilte2">双向赋能供应商和电商卖家的一站式S2B2C全球电子商务服务平台</div>
            <div class="seaceView">
                <input type="text" placeholder="请输入手机号">
                <div class="btn"><a style="color:#FFF;text-decoration: none;" href="https://www.oneboerp.com/new/productAdmin" target="_blank">免费试用</a></div>
            </div>
         </div>
         <div class="FootBottom u-p-t-40 u-p-b-60">
            <div class="u-min-width u-flex u-col-top u-row-between">
                <div class="footLeft">
                    <div class="u-m-t-50"><img style="height:65px" src="../../assets/myimage/logo.png"></div>
                </div>
                <ul class="footMemu u-flex u-col-top u-flex-1 u-m-l-80 u-m-t-20">
                    <li class="u-flex-1">
                        <div class="f-fff">企业介绍</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/generalAdmin')">关于我们</div>
                        <!-- <div class="f-999 u-m-t-16" @click="handleClick('/setWordAdmin')">董事长寄语</div> -->
                        <!-- <div class="f-999 u-m-t-16" @click="handleClick('/civilizationAdmin')">企业文化</div> -->
                    </li>
                    <li class="u-flex-1">
                        <div class="f-fff">业务板块</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/ERPShopAdmin')">物联网连接管理平台</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/ERPAdmin')">芯动云App</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/ERPSIM')">物联网卡</div>
                        <div class="f-999 u-m-t-16" > <a href="https://cxsd.cxsdiot.cn/login?redirect=%2Findex" target="_blank" style="color:#999999">前往创芯CMP连接管理平台</a></div>
                    </li>
                    <li class="u-flex-1">
                        <div class="f-fff">通信终端</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/commercialAdmin')">UFI</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/mediaAdmin')">MIFI</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/mediaAdmin')">CPE</div>
                    </li>
                     <li class="u-flex-1">
                        <div class="f-fff">联系我们</div>
                        <div class="f-999 u-m-t-16" @click="handleClick('/contactAdmin')">联系我们</div>
                        <!-- <div class="f-999 u-m-t-16" @click="handleClick('/contactAdmin')">人才招聘</div> -->
                    </li>
                </ul>
            </div>
            <!-- <div class="u-min-width u-p-t-40 u-flex u-col-top u-row-center">
                <span class="u-cursor"> 
                    <a href="https://cxsd.cxsdiot.cn/login?redirect=%2Findex" target="_blank">点击前往创芯CMP连接管理平台</a>
                </span>
            </div> -->
         </div>
           <div class="footbuttom">
            <span class="u-cursor">
                    &copy;&nbsp;&nbsp;创芯时代（深圳）技术有限公司版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">粤ICP备20042940号-2</a> | 
                    <i class="el-icon-location-information"></i>
                    深圳市光明区光明街道华夏二路 富森大厦9楼9A
                </span>
         </div>
    </div>
</template>
<script>
export default {
    name:"myNewFoot",
    props:{
       show:{
          type:Boolean,
          default: true
       }
    },
    data(){
        return {

        }
    },
     methods:{
          handleClick(url){
            this.$router.push({
                path:url
            })
          }
    }
}
</script>
<style lang="scss" scoped>
a{
     text-decoration: none;
      color: #FFF;
   }
  .myNewFoot{
      .FootTop{
         background-image: url("../../assets/images/newImg/footbanner.png");
         background-size: 100% 100%;
         & div{
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
         }
         .FootTilte{
            font-size: 36px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 400;
            color: #333333;
         }
         .FootTilte2{
            margin: 10px 0 30px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #888888;
         }
         .seaceView{
            width: 420px;
            height: 48px;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 2px solid #FD681C;
            display: flex;
            justify-content: space-between;
            align-items: center;
            input{
                flex: 1;
                height: 46px;
                border: none;
                outline: none;
                background: #FFF;
                padding:  0 10px 0 10px;
                font-size: 14px;
            }
            .btn{
                width: 91px;
                height: 100%;
                background: #FD681C;
                color: #FFF;
                cursor: pointer;
            }
         }
      }
     .FootBottom{
        background: #252D3F;
        .footLeft{
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
        .footMemu{
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            .f-fff{
                color:#FFF
            }
            .f-999{
              color: #999999;
            }
            li{
                div{
                    cursor: pointer;
                    &:hover{
                        color:#FFF
                    }
                }
            }
            
        }
        .footright{
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
     }
      .footbuttom{
            background: #333333;
            color:#FFF;
            text-align: center;
            padding: 16px 0;
        }
  }
</style>
<style lang="scss" scoped>
/*手机端*/
@media  screen and (max-width:760px) {
    .myNewFoot{
        display: none !important;
         
    }
   
}
</style>